import React, { useEffect, useState, useMemo } from "react";
import {
  AdvertisingDetailsType,
  BhpMarketTypes,
  BusinessDetailsType,
  BusinessHomePageSection,
  BusinessProductCategoryWithProducts,
  BussinessHomeCardData,
  TextCartItemType,
  theme,
} from "../pages/BussinessHomePage";
import {
  IonButton,
  IonCol,
  IonGrid,
  IonIcon,
  IonRow,
  IonSpinner,
} from "@ionic/react";
import BussinessHomeCard from "./BussinessHomeCard";
import BhpDirectoryCard from "./BhpDirectoryCard";
import {
  useAppSelector,
  useRecordUserInteractions,
  userActionsTable,
} from "../app/hooks";
import {
  mobileWidthBreakpoint,
  tabWidthBreakpoint,
} from "../types/form_table_data_types";
import { add, pricetag, remove } from "ionicons/icons";
import { getSeoUrl } from "../common/commonFunctions";
import {
  AdvanceCustomizationType,
  CartItemTypes,
  PositionType,
} from "../types/data_types";
import { getPageType } from "../types/constants";

const BhpSearchModalSection: React.FC<{
  sectionIdx: number;
  pageLocation: "MAIN" | "SEARCH";
  sectionObj: BusinessProductCategoryWithProducts;
  listModeListing?: number | boolean;
  adMaker?: boolean;
  idAdder?: string;
  subheaderTopOffsetPx?: number;
  showingFloorSelector?: boolean;
  marketMode?: boolean;
  adData?: AdvertisingDetailsType[];
  search?: string;
  bussinessDetailsDB: BusinessDetailsType;
  dismiss: () => void;
  buttonOverride?: {
    icon?: any;
    name?: string;
    onClick: (id: string | number) => void;
  };
  handleCheckoutOpen?: () => void;
  addItemizedFromText?: (
    name: string,
    hasEntry: boolean,
    cardData: BussinessHomeCardData
  ) => void;
  addOrderItemized: (name: string) => void;
  textCartItems?: TextCartItemType[];
  handleOpenCloseCard?: (id: any) => Promise<void>;
  vypzeePage: boolean;
  handleChildvariant?: (name: any) => void;
  handleChildAddToCart?: (
    type: any,
    firstTime: any,
    id: any,
    variantName: any,
    price: any
  ) => void;
  cartItems?: CartItemTypes[];
  expandingImgOpen?: Function;
  expandDetails?: (id: string | number) => void;
  recordUserInteractions?: boolean;
  pageSection?: "MAIN" | "SEARCH";
  navigate?: (
    location: { obj?: PositionType; url?: string },
    shopId: string,
    shopName: string
  ) => void;
  getMarketShowGetAllData?: (id: string | number, idx: number) => Promise<void>;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  const screenWidth = useAppSelector((state) => state.screenWidth).width;
  const isMob =
    useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;
  const isTab =
    useAppSelector((state) => state.screenWidth).width < tabWidthBreakpoint;
  const businessHomePageSectionOffsetPx =
    (props.subheaderTopOffsetPx ? props.subheaderTopOffsetPx : 0) +
    (props.showingFloorSelector ? 40 : 0);
  const filteredProd = props.sectionObj.products;
  // -1 : Enabled and show all, 0: Disabled and show all, n: enabled and show n
  const [showingListSize, setShowingListSize] = useState(0);
  const [marketShowGetAllData, setMarketShowGetAllData] = useState(false);
  const [loadingMarketShowGetAllData, setLoadingMarketShowGetAllData] =
    useState(false);
  const listModeListing = useMemo(() => {
    // return true;
    if (props.sectionObj?.listModeListing === 0) {
      return props.sectionObj?.listModeListing;
    } else {
      return props.listModeListing;
    }
  }, [props.bussinessDetailsDB, props.sectionObj, props.listModeListing]);

  useEffect(() => {
    if (!props.sectionObj.defaultMaxListSize) {
      setShowingListSize(0);
    } else {
      if (
        props.sectionObj.products.length > props.sectionObj.defaultMaxListSize
      )
        setShowingListSize(props.sectionObj.defaultMaxListSize);
      else setShowingListSize(0);
    }
    if (
      props.bussinessDetailsDB.isMarket &&
      props.bussinessDetailsDB.marketType === "MARKET" &&
      props.sectionObj.products.length !== props.sectionObj.numProducts &&
      !props.search
    ) {
      setMarketShowGetAllData(true);
    } else {
      setMarketShowGetAllData(false);
    }
  }, [props.sectionObj, props.bussinessDetailsDB]);

  const recordAction = useRecordUserInteractions();

  if (!filteredProd.length) return <></>;

  return (
    <BusinessHomePageSection
      img={props.sectionObj.catImgObj}
      classNames="filtered_buying"
      subheaderTopOffsetPx={businessHomePageSectionOffsetPx}
      headingLine={listModeListing ? false : true}
      subHeaderText={props.sectionObj.category}
      bgStyle={
        // props.sectionObj.isSpecial
        //   ? `linear-gradient(90deg, ${theme.yellowTheme.catProdSpecialBg[0]} 0%, ${theme.yellowTheme.catProdSpecialBg[1]} 100%)`
        theme.yellowTheme.catProdDefaultBg
      }
      isSpecial={props.sectionObj.isSpecial}
      enableSubheaderStickyScroll={true}
      subheaderId={`${props.idAdder}${props.sectionObj.category}`}
      supressSubheader={!filteredProd.length}
      description={props.sectionObj.categoryDescription}
      subHeaderButtons={
        listModeListing || props.vypzeePage
          ? []
          : props.sectionObj.domain
          ? [
              {
                color: "dark",
                fill: "clear",
                name: "Explore Market >",
                onClick: () => {
                  // window.location.assign(
                  //   `https://${props.sectionObj.domain}.vypzee.com`
                  // );
                  window.location.assign(
                    getSeoUrl(props.sectionObj?.seoUrlDetails, true)
                  );
                },
              },
            ]
          : [
              {
                color: "medium",
                fill: "clear",
                onClick: () => {},
                name: `${
                  props.sectionObj.numProducts
                    ? props.sectionObj.numProducts
                    : props.sectionObj.products.length
                }`,
              },
            ]
      }
      listModeListing={listModeListing || props.sectionObj.subHeaderPicMode}
    >
      <div style={{ height: "5px" }}></div>
      {props.sectionObj?.directoryMode && (
        <div
          className={
            props.sectionObj?.bannerText
              ? "bhp-search-modal-section-banner"
              : "bhp-search-modal-section-no-dir-banner"
          }
        >
          {!!props.sectionObj?.bannerText && (
            <>
              <IonIcon icon={pricetag} />
              <span style={{ paddingLeft: "8px" }}>
                {props.sectionObj?.bannerText}
              </span>
            </>
          )}
        </div>
      )}
      {!!filteredProd.length &&
        (props.marketMode || props.sectionObj.directoryMode) &&
        props.sectionObj.category !== "Products" &&
        filteredProd.map((el, idx) => {
          if (
            !!showingListSize &&
            showingListSize !== -1 &&
            idx >= showingListSize
          )
            return <div key={idx}></div>;
          const ads = el?.advertising?.length
            ? el.advertising
            : props?.adData?.filter((item) => item.shopDomain === el?.domain);
          // if (el.name.includes("Novax"))
          //   console.log("JDE ads", ads, " element ", el, " ads ", props.adData);
          return (
            <>
              {!idx && <div style={{ height: "5px" }}></div>}
              <BhpDirectoryCard
                rating={el.rating}
                key={idx}
                navigate={props.navigate}
                locationUrl={el.locationUrl}
                floorId={props.bussinessDetailsDB.floorId}
                location={el.location}
                searchText={props.search}
                adMaker={props.adMaker}
                adData={ads}
                fileName={el.imagePath ? el.imagePath[0] : ""}
                phone={el.phoneNumbers}
                title={el.name}
                subTitle={el.shortDescription}
                subscriptionType={el.subscriptionType}
                hasSpecials={el.hasSpecials}
                address={el.description}
                marketDomain={props.bussinessDetailsDB.domainName}
                marketId={
                  props.bussinessDetailsDB.isMarket
                    ? props.bussinessDetailsDB.id
                    : undefined
                }
                shopDomain={el.domain}
                imgObj={props.sectionObj.catIconImgObj}
                dismiss={props.dismiss}
                shopId={el.id}
                stockImg={el.stockImage}
                seoUrlDetails={el.seoUrlDetails}
                marketType={props.bussinessDetailsDB.marketType}
                pageId={props.bussinessDetailsDB.id}
                pageSection={props.pageSection}
                recordUserInteractions={props.recordUserInteractions}
                search={props.search}
              />
            </>
          );
        })}
      {!!filteredProd.length &&
        (!props.marketMode ||
          (props.marketMode && props.sectionObj.category === "Products")) &&
        !props.sectionObj.directoryMode && (
          <div className="bussiness-home-page-catalogue-wrpr">
            <IonGrid>
              <IonRow className="ionRow-business-catelogue">
                {filteredProd.map((el, idx) => {
                  const domain = el.domain ? el.domain : "";
                  const cardData: BussinessHomeCardData = {
                    advertising: el.advertising,
                    variant: el.variant,
                    id: el.id,
                    imagePath: el.imagePath,
                    text: !!el?.description
                      ? el.description
                      : el?.shortDescription,
                    title: el.name,
                    domain: domain,
                    productList: el.productList,
                    isSpecial: el.isSpecial,
                    subscriptionType: el?.subscriptionType,
                    subtitle: el?.subTitle,
                    seoUrlDetails: el?.seoUrlDetails,
                    isNotListed: el?.isNotListed,
                  };
                  // console.log("Variant data ", cardData);

                  return (
                    <IonCol
                      key={idx}
                      size={
                        !!listModeListing
                          ? "12"
                          : isMob
                          ? "6"
                          : isTab
                          ? "4"
                          : screenWidth < 1600
                          ? "3"
                          : "2"
                      }
                      className={!!listModeListing ? "prod-col" : ""}
                    >
                      <BussinessHomeCard
                        marketShowPrice={
                          props.bussinessDetailsDB.isMarket &&
                          props.sectionObj.category === "Products"
                        }
                        buttonOverride={props.buttonOverride}
                        listModeListing={listModeListing}
                        imgDivIdPostFix={`${props.sectionObj.category}-${props.idAdder}`}
                        openCart={props.handleCheckoutOpen}
                        textCartItems={props.textCartItems}
                        searchText={props.search}
                        addItemizedFromText={props.addItemizedFromText}
                        addOrderItemized={props.addOrderItemized}
                        // openPromo={() => {
                        //   setKcdelpromo(true);
                        // }}
                        subscriptionType={
                          props.bussinessDetailsDB.subscriptionType
                        }
                        openCloseCard={props.handleOpenCloseCard}
                        parentDomain={props.bussinessDetailsDB.domainName}
                        marketListing={
                          props.vypzeePage || props.bussinessDetailsDB.isMarket
                        }
                        variantIdCallBack={props.handleChildvariant}
                        addRemoveCartCallBack={props.handleChildAddToCart}
                        cartItems={props.cartItems}
                        theme={theme.yellowTheme}
                        isSpecial={props.sectionObj.isSpecial}
                        data={cardData}
                        fullHeight={true}
                        id={el.id}
                        openExpandImg={(filename, index) => {
                          if (props.expandingImgOpen)
                            props.expandingImgOpen({
                              fileName: filename,
                              index: index,
                              open: true,
                            });
                        }}
                        openDetails={(id) => {
                          recordAction({
                            action: userActionsTable.openProduct,
                            pageId: props.bussinessDetailsDB.id,
                            pageSection: props.pageLocation,
                            pageType: getPageType(
                              props.bussinessDetailsDB.isMarket,
                              props.bussinessDetailsDB.marketType
                            ),
                            popId: id,
                            popType: "PROD",
                            notes: `${props.sectionObj.category} :: ${cardData.title}`,
                          });
                          props?.expandDetails(id);
                        }}
                        isMarket={props.bussinessDetailsDB.isMarket}
                        businessDetails={props.bussinessDetailsDB}
                        nameCardMode={
                          props.bussinessDetailsDB.isMarket &&
                          props.bussinessDetailsDB.marketType === "RWA" &&
                          props.bussinessDetailsDB?.subType === "BNI-CHAPTER" &&
                          props.sectionObj.category === "Members"
                        }
                        advanceCustomization={props.advanceCustomization}
                      />
                      {/* <div style={{ width: "100%", padding: "0 10px" }}>
                        <div
                          style={{
                            width: "100%",
                            height: "1px",
                            background:
                              "linear-gradient(to right, var(--ion-color-medium), var(--ion-color-light))",
                          }}
                        ></div>
                      </div> */}
                    </IonCol>
                  );
                })}
              </IonRow>
            </IonGrid>
          </div>
        )}
      {/* </div> */}
      {marketShowGetAllData && (
        <IonButton
          color={"primary"}
          fill="clear"
          expand="block"
          onClick={() => {
            if (!props?.getMarketShowGetAllData) {
              return;
            }
            setLoadingMarketShowGetAllData(true);
            props.getMarketShowGetAllData(
              props.sectionObj.id,
              props.sectionIdx
            );
          }}
        >
          {loadingMarketShowGetAllData && <IonSpinner color={"primary"} />}
          {!loadingMarketShowGetAllData && (
            <>
              <IonIcon icon={add} slot="start" />
              Show All {props.sectionObj.numProducts} Stores
            </>
          )}
        </IonButton>
      )}
      {!!showingListSize && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: "5px",
          }}
        >
          <IonButton
            size="small"
            fill="solid"
            color={"medium"}
            onClick={() => {
              if (showingListSize === -1) {
                setShowingListSize(props.sectionObj.defaultMaxListSize);
              } else {
                setShowingListSize(-1);
              }
            }}
          >
            <IonIcon
              icon={showingListSize !== -1 ? add : remove}
              slot="start"
              color="light"
            />
            <span
              style={{
                textTransform: "none",
                // fontWeight: "bold",
                color: "var(--ion-color-light)",
              }}
            >
              {`${
                showingListSize === -1
                  ? "Collapse"
                  : `Show All ${props.sectionObj.products.length} Stores`
              }`}
            </span>
          </IonButton>
        </div>
      )}
    </BusinessHomePageSection>
  );
};
export default BhpSearchModalSection;
